import { httpClient } from '#shared'
import type { EmojiConfig } from '../model/emoji-config'

export async function getEmojiConfig() {
  const response = await httpClient.get<EmojiConfig>('resources/emojis.min.json', {
    prefixUrl: import.meta.env.DEV ? '/' : import.meta.env.VITE_BASEPATH,
  })
  const responseBody = await response.json()
  return responseBody
}
